import * as Sentry from '@sentry/react';
import { DGLayout } from '@tf/ui';
import { AppProvider } from '@/core/providers';
import { AppRouter } from '@/routes/AppRouter';

// import for side effect - add Mantine CSS
import '@tf/ui/lib/providers/MantineStyles';
import './App.css';

export const App = () => {
	return (
		<Sentry.ErrorBoundary fallback={<VanillaErrorPage />}>
			<DGLayout>
				<AppProvider>
					<AppRouter />
				</AppProvider>

				{/* TODO: this, but this requires appInstanceId which is in appMeta */}
				{/* 	we need more graceful useAppInstanceId hook */}
				{/*	<SentryInitialization />*/}
				{/*	<AmplitudeInitialization />*/}
			</DGLayout>
		</Sentry.ErrorBoundary>
	);
};

// we don't have a Mantine/Emotion provider at the top-level error boundary, so we're using plain css for this component
const VanillaErrorPage = () => {
	return (
		<div className="container">
			<div className="error-box">
				<div className="icon">
					<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M28.3333 36.6668V33.3335M15 25.0002L25 15.0002M18.3333 10.0003L19.105 9.10693C20.668 7.54414 22.7878 6.66627 24.9981 6.66642C27.2084 6.66658 29.3281 7.54476 30.8908 9.10777C32.4536 10.6708 33.3315 12.7906 33.3314 15.0009C33.3312 17.2111 32.453 19.3308 30.89 20.8936L30 21.6669M21.6669 30.0002L21.0052 30.8902C19.424 32.4538 17.2899 33.3308 15.0661 33.3308C12.8423 33.3308 10.7082 32.4538 9.12691 30.8902C8.34751 30.1195 7.72874 29.2019 7.30643 28.1904C6.88413 27.1789 6.66668 26.0937 6.66668 24.9977C6.66668 23.9016 6.88413 22.8164 7.30643 21.8049C7.72874 20.7935 8.34751 19.8758 9.12691 19.1052L10.0002 18.3335M33.3333 28.3335H36.6667M3.33334 11.6668H6.66668M11.6667 3.3335V6.66683"
							stroke="#111827"
							strokeWidth="3"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>
				<h3 className="title">Unexpected error</h3>
				<p className="message">Unexpected error occurred</p>
				<a className="link" onClick={() => window.location.reload()}>
					<span className="link-icon">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g clipPath="url(#clip0_2302_4620)">
								<path
									d="M20 11.0002C19.7554 9.24041 18.9391 7.60985 17.6766 6.35969C16.4142 5.10953 14.7758 4.30911 13.0137 4.08175C11.2516 3.85438 9.46362 4.21268 7.9252 5.10144C6.38678 5.9902 5.18325 7.36013 4.5 9.00019M4 5.00019V9.00019H8M4 13.0002C4.24456 14.76 5.06093 16.3905 6.32336 17.6407C7.58579 18.8909 9.22424 19.6913 10.9863 19.9186C12.7484 20.146 14.5364 19.7877 16.0748 18.899C17.6132 18.0102 18.8168 16.6403 19.5 15.0002M20 19.0002V15.0002H16"
									stroke="#2563EB"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</g>
							<defs>
								<clipPath id="clip0_2302_4620">
									<rect width="24" height="24" fill="white" />
								</clipPath>
							</defs>
						</svg>
					</span>
					<span>Reload this page</span>
				</a>
			</div>
		</div>
	);
};
